import { render } from "./notice_treaty.vue?vue&type=template&id=193a2dcd&scoped=true"
import script from "./notice_treaty.vue?vue&type=script&lang=js"
export * from "./notice_treaty.vue?vue&type=script&lang=js"

import "./css/contact.scss?vue&type=style&index=0&id=193a2dcd&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193a2dcd"]])

export default __exports__